import SellerTableHelper from './seller-table-helper';


const SellerHelpers = {
    TableMain: SellerTableHelper,
}

export default SellerHelpers;